<template>
  <v-container fluid grid-list-sm>
    <v-card v-if="mode === 'list'">
      <v-toolbar :dense="true"  >
        <v-toolbar-title class="body-2"> <v-icon>mdi-redo-variant</v-icon> XOL Recoveries </v-toolbar-title>
        <v-spacer></v-spacer>
        <span class="body-2">Claim No: {{ this.commonInfo.clmNo }}</span>
      </v-toolbar>
      <v-data-table :headers="paymentColumns" :items="xolList" class="elevation-1" hide-default-footer>
        <template v-slot:item="row"
          ><tr>
            <td>{{ row.item.clmtNo }}</td>
            <td>{{ row.item.clmItem }}</td>
            <td>{{ row.item.clmResCat }}</td>
            <td>{{ row.item.riType }}</td>
            <td>{{ row.item.riCo }}</td>
            <td>{{ row.item.curr }}</td>
            <td class="text-right">{{ formatDisplayPrice(row.item.rcvyAmt) }}</td>
            <td class="text-right">{{ formatDisplayPrice(row.item.rcvredAmt) }}</td>
            <td v-if="false">{{ row.item.modifiedDate }}</td>
            <td v-if="false">{{ row.item.modifiedBy }}</td>
            <td v-if="false">{{ row.item.createdDate }}</td>
            <td v-if="false">{{ row.item.createdBy }}</td>
            <td><v-btn icon color="primary" text @click.native="openForm('update',row.item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn></td>
          </tr></template
        >
      </v-data-table>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="primary" @click.native="openForm('new', null)">
          <span>XOL Recoveries</span>
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
        <v-spacer />
        <v-btn color="red darken-1" text @click.native="doClose">Close</v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-if="mode === 'new' || mode === 'update'">
      <v-toolbar :dense="true" >
        <v-toolbar-title> <v-icon>mdi-history</v-icon>{{this.toolbarTitle}}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-flex sm6>
            <v-text-field
            :label="labels.clmNo"
                  v-model=this.commonInfo.clmNo
                  :disabled="true"
                  readonly
            ></v-text-field>
        </v-flex>
        <v-layout row wrap>
          <v-flex sm6>
                <v-text-field
                  :label="labels.clmtAndItem"
                  v-model="clmtAndItemDesc"
                  v-validate="'required'"
                  :error-messages="errors.collect('clmtAndItem')"
                  data-vv-name="clmtAndItem"
                  :data-vv-as="labels.clmtAndItem"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('claimItem')"
                  @click="getHelpList('claimItem')"
                  :disabled="isDisabled"
                  readonly
                ></v-text-field>
          </v-flex>
          <v-flex sm6>
                <v-text-field
                  :label="labels.clmResCat"
                  v-model="clmResCatDesc"
                  v-validate="'required'"
                  :error-messages="errors.collect('clmResCat')"
                  data-vv-name="clmResCat"
                  :data-vv-as="labels.clmResCat"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('clmResCat')"
                  @click="getHelpList('clmResCat')"
                  :disabled="isDisabled"
                  readonly
                ></v-text-field>
          </v-flex>
          <!-- <v-flex sm6>
                <v-text-field
                  :label="labels.clmtItemResCat"
                  v-model="clmtItemResCatDesc"
                  v-validate="'required'"
                  :error-messages="errors.collect('clmtItemResCat')"
                  data-vv-name="clmtItemResCat"
                  :data-vv-as="labels.clmtItemResCat"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('clmtItemResCat')"
                  readonly
                ></v-text-field>
          </v-flex> -->
        </v-layout>
        <v-layout row wrap>
          <v-flex sm6>
            <v-select v-model="xolForm.riType" :items="riTypeList" :label="labels.riType"
            item-text="label" item-value="value" :data-vv-as="labels.riType"
            :error-messages="errors.collect('xolForm.riType')"
            v-validate="'required'" data-vv-name="xolForm.riType"
            :disabled="isDisabled" />
          </v-flex>
          <v-flex sm6>
            <v-text-field
            :label="labels.riCompany"
                  v-model="xolForm.riCompany" :data-vv-as="labels.riCompany" data-vv-name="xolForm.riCompany"
                  :error-messages="errors.collect('xolForm.riCompany')"
                  :disabled="isDisabled"
                  v-validate="'entry|max:8'"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
        <v-flex sm4>
          <cal-picker v-model="xolForm.tranDate" :label="labels.tranDate"
          :data-vv-as="labels.tranDate" data-vv-name="xolForm.tranDate"
          :error-messages="errors.collect('xolForm.tranDate')"
          v-validate="'required'"
          :disabled="isDisabled"/>
        </v-flex>
        <v-flex sm4>
            <v-text-field
            :label="labels.acctMth"
                  v-model="xolForm.acctMth"
                  :disabled="true"
                  readonly
            ></v-text-field>
        </v-flex>
        <v-flex sm4>
            <v-text-field
            :label="labels.acctYr"
                  v-model="xolForm.acctYr"
                  :disabled="true"
                  readonly
            ></v-text-field>
        </v-flex>
        </v-layout>
        <v-layout row wrap>
        <v-flex sm6>
            <v-text-field
            :label="labels.rcvyAmt"
            v-model="xolForm.rcvyAmt"
            data-vv-name="xolForm.rcvyAmt"
            v-validate="'mask_decimal:2|mask_max_value:9999999999999999.99|mask_min_value:0.00'"
            ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex sm6>
            <v-text-field
            :label="labels.rcvdAmt"
            v-model="xolForm.rcvdAmt"
            data-vv-name="xolForm.rcvdAmt"
            v-validate="'mask_decimal:2|mask_max_value:9999999999999999.99|mask_min_value:0.00'"
            ></v-text-field>
        </v-flex>
      </v-layout>
      <!-- <v-layout row wrap>
        <v-flex sm6>
            <v-text-field
            :label="labels.rcvdAmtLoc"
                  v-model="xolForm.rcvdAmtLoc"
            ></v-text-field>
        </v-flex>
      </v-layout> -->
        <v-layout row wrap>
          <v-flex xs6>
            <v-text-field
            :label="labels.createdBy"
            v-model="xolForm.createdBy"
            :disabled="true"
            ></v-text-field>
          </v-flex>
          <v-flex xs6>
            <cal-picker
            v-model="xolForm.createdDate"
            :label="labels.createdDate"
            :data-vv-as="labels.createdDate"
            data-vv-name="xolForm.createdDate"
            :disabled="true"
            />
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6 v-if="xolForm.modifiedBy">
            <v-text-field
            :label="labels.modifiedBy"
            v-model="xolForm.modifiedBy"
            :disabled="true"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 v-else>
            <v-text-field
            :label="labels.modifiedBy"
            v-model="xolForm.createdBy"
            :disabled="true"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 v-if="xolForm.modifiedDate">
            <cal-picker
            v-model="xolForm.modifiedDate"
            :label="labels.modifiedDate"
            :data-vv-as="labels.modifiedDate"
            data-vv-name="xolForm.modifiedDate"
            :disabled="true"
            />
          </v-flex>
          <v-flex xs6 v-else>
            <cal-picker
            v-model=xolForm.createdDate
            :label="labels.modifiedDate"
            :data-vv-as="labels.modifiedDate"
            data-vv-name="xolForm.modifiedDate"
            :disabled="true"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click.prevent="doValid" :loading="loading">Save</v-btn>
        <v-btn color="red darken-1" text @click.native="mode = 'list'">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  <v-dialog v-model="showClaimItemHelpList" width="1080px">
      <claim-item-help-list
        :claimNo="commonInfo.clmNo"
        @close="showClaimItemHelpList = false"
        @assign-claimItem-info="doAssign('claimItem', $event)"
      ></claim-item-help-list>
  </v-dialog>
  <v-dialog v-model="showClaimReserveHelpList" width="1080px">
      <claim-reserve-help-list
        :busCls="commonInfo.busCls"
        @close="showClaimReserveHelpList = false"
        @assign-reserve-info="doAssign('claimRes', $event)"
      ></claim-reserve-help-list>
  </v-dialog>
  </v-container>
</template>

<script>
import { formatDisplayDate, formatDisplayDateTime4, removeTime } from '@/utils/date'
import MessageMixin from '@/mixins/message'
import { parseISO, isAfter, isBefore, isEqual } from 'date-fns'
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import { formatPrice } from '@/utils/index'
import ClaimItemHelpList from '@/components/core/claimManagement/helpList/ClaimItemHelpList'
import ClaimReserveHelpList from '@/components/core/claimManagement/helpList/ClaimReserveHelpList'
import { riListMixin } from '@/mixins/reinsurance/riListMixin'
export default {
  data() {
    return {
      loading: false,
      mode: 'list',
      labels: {
        clmNo: 'Claim No',
        clmtAndItem: 'Claimant / Item No',
        clmResCat: 'Reserve Category',
        clmtItemResCat: 'Claimant / Item No / Reserve Category',
        riType: 'RI Type',
        riCompany: 'Treaty Ref',
        tranDate: 'Transaction Date',
        acctMth: 'Account Month',
        acctYr: 'Account Year',
        rcvyAmt: 'Recovery Amount',
        rcvdAmt: 'Recovered Amount',
        rcvdAmtLoc: 'Recovered Amount Local',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      xolForm: {
        clmNo: undefined,
        clmtNo: 0,
        clmItem: 0,
        clmResCat: undefined,
        riType: 'T',
        riCompany: undefined,
        tranDate: new Date(),
        acctMth: 0,
        acctYr: 0,
        rcvyCurr: 'SGD',
        rcvyAmt: 0.0,
        rcvdAmt: 0.0,
        rcvdAmtLoc: 0.0,
        createdBy: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
        createdDate: new Date(),
        modifiedBy: '',
        modifiedDate: null,
        currentDate: new Date()
      },
      riTypeList: [
        { label: 'Treaty', value: 'T' },
        { label: 'Facultative', value: 'F' }
      ],
      paymentColumns: [
        { text: 'Clmt No', align: 'left', value: 'clmNo' },
        { text: 'Clm Item', align: 'left', value: 'clmItem' },
        { text: 'Res Cat', align: 'left', value: 'clmResCat' },
        { text: 'RI Type', align: 'left', value: 'riType' },
        { text: 'RI Co', align: 'left', value: 'riCo' },
        { text: 'Rcvy Curr', align: 'left', value: 'curr' },
        { text: 'Rcvy Amt', align: 'right', value: 'rcvyAmt' },
        { text: 'Rcvd Amt', align: 'right', value: 'rcvredAmt' },
        // { text: 'Rcvd Amt Loc', align: 'right', value: 'rcvredAmtLoc' },
        // { text: 'Suffix', align: 'left', value: 'acctNoSfx' },
        // { text: 'Tran Date', align: 'left', value: 'tranDate' },
        // { text: 'Acct Month', align: 'left', value: 'acctMth' },
        // { text: 'Acct Year', align: 'left', value: 'acctYr' },
        // { text: 'Entry Date', align: 'left', value: 'createdDate' },
        // { text: 'User ID', align: 'left', value: 'createdBy' },
        { text: 'Action', align: 'left', value: 'action' }
      ],
      trandaterange: {},
      showClaimItemHelpList: false,
      showClaimReserveHelpList: false,
      showClaimtItemReserveHelpList: false,
      clmtAndItem: '',
      clmtItemType: '',
      clmtAndItemDesc: '',
      clmRes: '',
      clmResCat: '',
      clmResCatDesc: '',
      clmtItemResCatDesc: '',
      acctYr: 0,
      acctMth: 0,
      isDisabled: false,
      xolList: []
    }
  },
  mounted() {
    this.doFetch()
  },
  computed: {
    claimDetail() {
      return this.$store.state.claims.claimDetail
    },
    commonInfo() {
      return this.$store.state.claims.claimDetail.commonInfo
    },
    tranDate() {
      return this.$store.state.claims.claimDetail.tranDate || new Date()
    },
    riRecoveries() {
      return this.commonInfo.xolRcvys
    },
    tDateRange() {
      return this.trandaterange
    },
    doValidateDate() {
      const today = new Date()
      return 'required|statDate:' + this.tDateRange.effDate + ',' + this.tDateRange.expDate + '|valDate:' + today
    },
    toolbarTitle() {
      if (this.mode === 'new') {
        return 'New XOL Recoveries'
      } else if (this.mode === 'update') {
        return 'Update  XOL Recoveries'
      }
      return 'XOL Recoveries'
    }
  },
  created() {
    this.$validator.extend('tranDate', {
      getMessage(field, args) {
        return 'Date not within permitted Date Range.(17)'
      },
      validate(value, args) {
        let effDate = args[0]
        let expDate = args[1]
        if (value) {
          return (isAfter(removeTime(value), removeTime(effDate)) || isEqual(removeTime(value), removeTime(effDate))) &&
          (isBefore(removeTime(value), removeTime(expDate)) || isEqual(removeTime(value), removeTime(expDate)))
        } else return true
      }
    })
    this.updateAcctInfo(this.xolForm.tranDate)
  },
  watch: {
    'xolForm.tranDate': 'updateAcctInfo'
  },
  methods: {
    async doFetch() {
      this.xolList = []
      if (this.mode === 'list') {
        const apiUrl = this.$store.state.claims.claimDetail.menu.getXOLRecoveries
        if (apiUrl) {
          const expand = {
            clmNo: this.commonInfo.clmNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result && result.data) {
            this.xolList = []
            result.data.map((xol) => {
              const convertXol = {
                clmtNo: xol.clmtNo,
                clmItem: xol.clmItem,
                clmResCat: xol.clmResCat,
                acctNoSfx: xol.acctNoSfx,
                riCo: xol.riCo,
                riType: xol.riType,
                curr: xol.rcvyCurr,
                rcvyAmt: xol.rcvyAmt,
                rcvredAmt: xol.rcvredAmt,
                // rcvredAmtLoc: xol.rcvredAmtLoc,
                tranDate: xol.tranDate,
                acctMth: xol.acctMth,
                acctYr: xol.acctYr,
                rcvyDocNo: xol.rcvyDocNo,
                createdDate: xol.createdDate,
                createdBy: xol.createdByName,
                modifiedBy: xol.modifiedByName,
                modifiedDate: xol.modifiedDate,
                clmtAndItemDesc: xol.clmtAndItemDesc,
                clmResCatDesc: xol.clmResCatDesc,
                ttyRiCoDesc: xol.ttyRiCoDesc

              }
              this.xolList.push(convertXol)
            })
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    openForm(status, data) {
      this.mode = status
      if (data !== null) {
        this.isDisabled = true
        this.clmtAndItemDesc = data.clmtAndItemDesc
        this.clmResCatDesc = data.clmResCatDesc
        this.xolForm.clmtNo = data.clmtNo
        this.xolForm.clmItem = data.clmItem
        this.xolForm.clmResCat = data.clmResCat
        this.xolForm.riType = data.riType
        this.xolForm.riCompany = data.riCo
        this.xolForm.tranDate = parseISO(data.tranDate)
        this.xolForm.acctMth = data.acctMth
        this.xolForm.acctYr = data.acctYr
        this.xolForm.rcvyAmt = data.rcvyAmt
        this.xolForm.rcvdAmt = data.rcvredAmt
        this.xolForm.rcvdAmtLoc = data.rcvredAmtLoc
        this.xolForm.createdBy = data.createdBy
        this.xolForm.createdDate = data.createdDate
        this.xolForm.modifiedDate = data.modifiedDate
        this.xolForm.modifiedBy = data.modifiedBy
      } else {
        this.resetMessages()
        this.resetValidator()
        this.isDisabled = false
        this.clmtAndItemDesc = undefined
        this.clmResCatDesc = undefined
        this.xolForm.clmtNo = undefined
        this.xolForm.clmItem = undefined
        this.xolForm.clmResCat = undefined
        this.xolForm.riType = 'T'
        this.xolForm.riCompany = undefined
        this.xolForm.tranDate = new Date()
        this.xolForm.acctMth = undefined
        this.xolForm.acctYr = undefined
        this.xolForm.rcvyAmt = 0.0
        this.xolForm.rcvdAmt = 0.0
        this.xolForm.rcvdAmtLoc = 0.0
        this.xolForm.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
        this.xolForm.createdDate = new Date()
        this.xolForm.modifiedDate = undefined
      }
    },
    formatBoolean(value) {
      if (value) {
        return 'Yes'
      }
      return 'No'
    },
    doClose() {
      this.resetMessages()
      this.resetValidator()
      this.$emit('close')
    },
    formatDisplayDate(value) {
      if (value) {
        return formatDisplayDate(value)
      } else {
        return ''
      }
    },
    formatDisplayDateTime(value) {
      if (value) {
        return formatDisplayDateTime4(value)
      } else {
        return ''
      }
    },
    formatDisplayPrice(value) {
      return formatPrice(value)
    },
    async updateAcctInfo(newDate) {
      if (this.mode === 'new') {
        const result = await this.getAcctMthYr(newDate)
        if (result) {
          const data = {
            acctMth: result.data.acctPerMth,
            acctYr: result.data.acctPerYr
          } // Adjust based on the actual response structure
          this.xolForm.acctMth = data.acctMth
          this.xolForm.acctYr = data.acctYr
        }
      }
    },
    async getTranDateRange() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.getCommonData('trandaterange', '200')
    },
    async getAcctMthYr(newDate) {
      const apiUrl = this.$store.state.claims.claimDetail.menu.getAcctYrMth
      if (apiUrl) {
        try {
          const expand = {
            tranDate: newDate
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          return result
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
      return null
    },
    parseDateISO(value) {
      if (value) {
        return parseISO(value)
      }
    },
    doAssign(field, data) {
      switch (field) {
        case 'claimItem':
          this.clmtAndItem = data.value
          this.clmtAndItemDesc = data.label
          let clmtItem = this.clmtAndItem.split(';')
          this.xolForm.clmtNo = clmtItem[0]
          this.xolForm.clmItem = clmtItem[1]
          break
        case 'claimRes':
          this.clmResCat = data.value
          this.clmResCatDesc = data.label
          this.xolForm.clmResCat = data.value
          break
      }
    },
    getHelpList(field) {
      switch (field) {
        case 'claimItem':
          this.showClaimItemHelpList = true
          break
        case 'clmResCat':
          this.clmRes = field
          this.showClaimReserveHelpList = true
          break
        case 'clmtItemResCat':
          this.showClaimtItemReserveHelpList = true
          break
      }
    },
    doValid() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.saveXOLRcvy()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async saveXOLRcvy() {
      const apiUrl = this.$store.state.claims.claimDetail.menu.saveXOLRcvy
      if (apiUrl) {
        try {
          const XOLDate = {
            clmNo: this.commonInfo.clmNo,
            clmtNo: this.xolForm.clmtNo,
            clmItem: this.xolForm.clmItem,
            clmResCat: this.xolForm.clmResCat,
            riType: this.xolForm.riType,
            riCo: this.xolForm.riCompany,
            tranDate: this.xolForm.tranDate,
            acctMth: this.xolForm.acctMth,
            acctYr: this.xolForm.acctYr,
            rcvyCurr: this.xolForm.rcvyCurr,
            rcvyAmt: this.xolForm.rcvyAmt,
            rcvredAmt: this.xolForm.rcvdAmt,
            rcvredAmtLoc: this.xolForm.rcvdAmt
          }
          const result = await this.$http.post(apiUrl, XOLDate)
          if (result) {
            this.mode = 'list'
            this.doFetch()
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  components: {
    ClaimItemHelpList,
    ClaimReserveHelpList
  },
  mixins: [MessageMixin, TableConst.default, riListMixin]
}
</script>

<style>
</style>
